import React from 'react'
import {connect} from 'react-redux'
import {compose, lifecycle} from 'recompose'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {formValueSelector, reduxForm} from 'redux-form'
import styled, {css} from 'react-emotion'
import Tooltip from '../../../share/Tooltip'
import Loading from '../../../share/Loading'
import {
  getVehicleYearOption,
  getVehicleBrandOption,
  getVehicleModelOption,
  getVehicleSubModelOption,
  getVehicleEngineSizeOption,
  setDataOptions,
} from '../../../../ducks/options'
import {using, redLicense} from '../../options'

import {
  inRange,
  displayNumber,
  numberParser,
  url2Obj,
} from '../../../../core/helper'
import Button from '../../../share/Button'
import CustomField from '../../../share/Field'
import {responsive} from '../../../../core/style'

const CustomTooltip = styled(Tooltip)`
  &.ant-tooltip {
    > .ant-tooltip-content {
      > .ant-tooltip-arrow {
        border-right-color: #7f7f7f;
      }
      > .ant-tooltip-inner {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        background-color: #7f7f7f;
      }
    }
  }
`

const Container = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const CarInfoFormHeader = styled.div`
  margin-top: 30px;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 40px;

  ${props =>
    responsive.mobile(css`
      max-width: 150px;
      text-align: center;
    `)};
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  ${props =>
    responsive.mobile(css`
      min-width: 280px;
    `)};
`

const Selector = styled(CustomField)`
  width: 355px;
  .label {
    min-width: 120px;
  }

  ${props =>
    responsive.mobile(css`
      width: 100%;
      flex-direction: column;

      .label {
        min-width: 120px;
        justify-content: flex-start;
        margin-bottom: 15px;
      }
    `)};
`

const SmallSelector = styled(CustomField)`
  width: 275px;
  .label {
    min-width: 120px;
  }

  ${props =>
    responsive.mobile(css`
      width: 100%;
      flex-direction: column;

      .label {
        min-width: 120px;
        justify-content: flex-start;
        margin-bottom: 15px;
      }
    `)};
`

const LargeSelector = styled(CustomField)`
  width: 531px;
  .label {
    min-width: 120px;
  }
  .input-selector-container > div {
    height: 80px;
  }

  ${props =>
    responsive.mobile(css`
      width: 100%;
      flex-direction: column;

      .label {
        min-width: 120px;
        justify-content: flex-start;
        margin-bottom: 15px;
      }
    `)};
`

const TextInput = styled(CustomField)`
  width: 355px;
  .label {
    min-width: 120px;
  }

  ${props =>
    responsive.mobile(css`
      width: 100%;
      flex-direction: column;

      .label {
        min-width: 120px;
        justify-content: flex-start;
        margin-bottom: 15px;
      }
    `)};
`
const SmallTextInputResponsive = styled(CustomField)`
  display: none;
  ${props =>
    responsive.mobile(css`
      display: unset;
      width: 100%;
      flex-direction: column;

      .label {
        min-width: 120px;
        justify-content: flex-start;
        margin-bottom: 15px;
      }

      input {
        text-align: center;
      }
    `)};
`

const SmallTextInput = styled(CustomField)`
  width: 235px;
  .label {
    min-width: 120px;
  }

  ${props =>
    responsive.mobile(css`
      display: none;
    `)};
`

const Radios = styled(CustomField)`
  width: fit-content;
  .label {
    min-width: 120px;
  }

  ${props =>
    responsive.mobile(css`
      width: 100%;
      flex-direction: column;

      .label {
        min-width: 120px;
        justify-content: flex-start;
        margin-bottom: 15px;
      }
      .input-radios-container {
        justify-content: center;
      }
      .ant-radio-group {
        width: 100px;
        height: 100%;
      }
      .ant-radio-wrapper {
        margin-right: 0;
        margin-bottom: 15px;
      }
    `)};
`

const CustomButton = styled(Button)`
  min-width: 150px;
  font-size: 12px;
  margin-right: 40px;
  margin-top: 15px;
  margin-bottom: 35px;

  ${props =>
    responsive.mobile(css`
      margin-right: 0;
    `)};
`

const CustomYearContainer = styled.div`
  display: flex;

  ${props =>
    responsive.mobile(css`
      flex-direction: column;
    `)};
`

const CarValueContainer = styled(CustomYearContainer)`
  display: flex;

  ${props =>
    responsive.mobile(css`
      position: relative;
    `)};
`

const Unit = styled.span`
  font-size: 16px;
  padding-top: 8px;
  margin-left: 18px;

  ${props =>
    responsive.mobile(css`
      display: none;
    `)};
`
const CustomIcon = styled(FontAwesomeIcon)`
  font-size: 20px;
  margin-top: 9px;
  margin-left: 25px;
  cursor: pointer;
  color: #7f7f7f;

  ${props =>
    responsive.mobile(css`
      position: absolute;
      right: 0;
      margin-top: 0;
    `)};
`

export const CarInfoForm = ({
  buttonText,
  handleSubmit,
  vehicleYearOption,
  getVehicleBrandOption,
  vehicleBrandOptions,
  getVehicleModelOption,
  vehicleModelOptions,
  getVehicleSubModelOption,
  vehicleSubModelOptions,
  getVehicleEngineSizeOption,
  vehicleEngineSizeOptions,
  optionsList,
  nextPage,
  change,
  setDataOptions,
  isLoading,
}) => (
  <Loading isLoading={isLoading}>
    <Container>
      <CarInfoFormHeader>กรุณากรอกข้อมูลรถยนต์ของคุณ</CarInfoFormHeader>
      <FormContainer>
        <CustomYearContainer>
          <SmallSelector
            name="vehicleYear"
            label="ปีรถยนต์"
            type="selector"
            placeholder="ปีรถยนต์"
            options={vehicleYearOption}
            themeColor="orange"
            didChange={value => {
              getVehicleBrandOption(value)
              change('vehicleBrandId', '')
              change('vehicleModelId', '')
              change('idKey', '')
              change('engineSize', '')
              setDataOptions({
                vehicleBrandOptions: [],
                vehicleModelOptions: [],
                vehicleSubModelOptions: [],
                vehicleEngineSizeOptions: [],
              })
            }}
          />
          {/* <SmallTextInput
            name="driverBirthYear"
            label="หรือใช้งานมาแล้ว"
            type="text"
            placeholder="ปีรถยนต์"
            normalize={inRange(0, 100)}
            format={displayNumber}
            parse={numberParser}
            themeColor="orange"
          />
          <SmallTextInputResponsive
            name="driverBirthYear"
            label="หรือใช้งานมาแล้ว (ปี)"
            type="text"
            placeholder="ปีรถยนต์"
            normalize={inRange(0, 100)}
            format={displayNumber}
            parse={numberParser}
            themeColor="orange"
          />
          <Unit>ปี </Unit> */}
        </CustomYearContainer>
        <Selector
          name="vehicleBrandId"
          label="ยี่ห้อรถยนต์"
          type="selector"
          placeholder="ยี่ห้อรถยนต์"
          options={vehicleBrandOptions}
          themeColor="orange"
          didChange={value => {
            getVehicleModelOption(optionsList.vehicleYear, value)
            change('vehicleModelId', '')
            change('idKey', '')
            change('engineSize', '')
            setDataOptions({
              vehicleModelOptions: [],
              vehicleSubModelOptions: [],
              vehicleEngineSizeOptions: [],
            })
          }}
        />
        <Selector
          name="vehicleModelId"
          label="รุ่นรถยนต์"
          type="selector"
          placeholder="รุ่นรถยนต์"
          options={vehicleModelOptions}
          themeColor="orange"
          didChange={value => {
            getVehicleSubModelOption(
              optionsList.vehicleYear,
              optionsList.vehicleBrandId,
              value,
            )
            change('idKey', '')
            change('engineSize', '')
            setDataOptions({
              vehicleSubModelOptions: [],
              vehicleEngineSizeOptions: [],
            })
          }}
        />
        <LargeSelector
          name="idKey"
          label="รุ่นย่อยรถยนต์"
          type="selector"
          placeholder="รุ่นย่อยรถยนต์"
          options={vehicleSubModelOptions}
          themeColor="orange"
          didChange={value => {
            const findPrice = vehicleSubModelOptions.find(
              val => val.value === value,
            )
            getVehicleEngineSizeOption(
              optionsList.vehicleYear,
              optionsList.vehicleBrandId,
              optionsList.vehicleModelId,
            )

            change(
              'carValue',
              findPrice.avgPrice ? findPrice.avgPrice : findPrice.price,
            )
            change('engineSize', '')
            setDataOptions({
              vehicleEngineSizeOptions: [],
            })
          }}
        />
        {/* <Selector
          name="engineSize"
          label="ขนาดเครื่องยนต์"
          type="selector"
          placeholder="ขนาดเครื่องยนต์"
          options={vehicleEngineSizeOptions}
          themeColor="orange"
        /> */}
        <Radios
          name="carUsage"
          label="การใช้งาน"
          type="radios"
          options={using}
        />
        {/* <Radios
          name="redLabel"
          label="ป้ายแดง"
          type="radios"
          options={redLicense}
        /> */}
        <CarValueContainer>
          <TextInput
            name="carValue"
            label="มูลค่ารถยนต์"
            type="text"
            placeholder="มูลค่ารถยนต์"
            format={displayNumber}
            parse={numberParser}
            disabled
          />
          <Unit>บาท</Unit>
          <CustomTooltip
            placement="right"
            title="คุณสามารถปรับเพิ่มลดมูลค่ารถยนต์เองได้">
            <CustomIcon icon={['fas', 'info-circle']} />
          </CustomTooltip>
        </CarValueContainer>
      </FormContainer>
      <CustomButton onClick={() => nextPage()} icons={['fa', 'search']}>
        {buttonText}
      </CustomButton>
    </Container>
  </Loading>
)

const select = formValueSelector('Planning')

const enhancer = compose(
  connect(
    (state, props) => ({
      vehicleYearOption: state.options.vehicleYearOption,
      vehicleBrandOptions: state.options.vehicleBrandOptions,
      vehicleModelOptions: state.options.vehicleModelOptions,
      vehicleSubModelOptions: state.options.vehicleSubModelOptions,
      vehicleEngineSizeOptions: state.options.vehicleEngineSizeOptions,
      isLoading: state.options.isLoading,

      initialValues: {
        carUsage: '110',
        redLabel: true,
        deduct: 'Y',
        insuranceLevel: url2Obj((props.location || {}).search || {})
          .insuranceLevel || ['2', '3'],
        vehicleYear: url2Obj(props.location.search).vehicleYear,
        vehicleBrandId: url2Obj(props.location.search).vehicleBrandId,
        vehicleModelId: url2Obj(props.location.search).vehicleModelId,
        idKey: url2Obj(props.location.search).idKey,
        engineSize: url2Obj(props.location.search).engineSize,
        driverBirthYear: url2Obj(props.location.search).driverBirthYear,
        carValue: url2Obj(props.location.search).carValue,
        ...url2Obj(props.location.search),
        cover: url2Obj(props.location.search).cover,
        coverCarSelfRepair:
          url2Obj(props.location.search).coverCarSelfRepair === 'true' ||
          url2Obj(props.location.search).coverCarSelfRepair === true,
        specifyOtherDriver:
          url2Obj(props.location.search).specifyOtherDriver === 'true' ||
          url2Obj(props.location.search).specifyOtherDriver === true,
      },

      optionsList: select(
        state,
        'vehicleYear',
        'vehicleBrandId',
        'vehicleModelId',
        'vehicleSubModel',
        'idKey',
      ),
    }),
    {
      getVehicleYearOption,
      getVehicleBrandOption,
      getVehicleModelOption,
      getVehicleSubModelOption,
      getVehicleEngineSizeOption,
      setDataOptions,
    },
  ),

  reduxForm({
    form: 'Planning',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),

  lifecycle({
    componentDidMount() {
      const {
        getVehicleYearOption,
        getVehicleBrandOption,
        getVehicleModelOption,
        getVehicleSubModelOption,
        getVehicleEngineSizeOption,
        setDataOptions,
      } = this.props

      getVehicleYearOption()

      if (url2Obj(this.props.location.search).vehicleYear) {
        getVehicleBrandOption(url2Obj(this.props.location.search).vehicleYear)
      }

      if (url2Obj(this.props.location.search).vehicleBrandId) {
        getVehicleModelOption(
          url2Obj(this.props.location.search).vehicleYear,
          url2Obj(this.props.location.search).vehicleBrandId,
        )
      }
      if (url2Obj(this.props.location.search).vehicleModelId) {
        getVehicleSubModelOption(
          url2Obj(this.props.location.search).vehicleYear,
          url2Obj(this.props.location.search).vehicleBrandId,
          url2Obj(this.props.location.search).vehicleModelId,
        )
      }
      if (url2Obj(this.props.location.search).idKey) {
        getVehicleEngineSizeOption(
          url2Obj(this.props.location.search).vehicleYear,
          url2Obj(this.props.location.search).vehicleBrandId,
          url2Obj(this.props.location.search).vehicleModelId,
          url2Obj(this.props.location.search).idKey,
        )
      }

      setDataOptions({
        vehicleBrandOptions: [],
        vehicleModelOptions: [],
        vehicleSubModelOptions: [],
        vehicleEngineSizeOptions: [],
      })
    },
  }),
)

export default enhancer(CarInfoForm)
